import {type Directive, type DirectiveBinding} from 'vue';

function updateCharsCount(container: HTMLDivElement, remainingCharsCount: number)
{
    container.innerText = 'Verbleibende Zeichen: ' + remainingCharsCount;
}

const maxChars: Directive = {
    mounted(element: HTMLElement, directiveOptions: DirectiveBinding)
    {
        const maxChars = directiveOptions.value;

        if (!(element instanceof HTMLInputElement) && !(element instanceof HTMLTextAreaElement) || !maxChars)
        {
            return;
        }

        const maxCharsContainer = document.createElement('div');
        element.after(maxCharsContainer);

        const update = (event: Nullable<Event> = null) =>
        {
            const remainingCharsCount = maxChars - element.value.length;

            if (remainingCharsCount < 0 && typeof element._vPortunaMaxCharsValue !== 'undefined')
            {
                element.value = element._vPortunaMaxCharsValue;
                event && event.preventDefault();
                return;
            }

            element._vPortunaMaxCharsValue = element.value;

            updateCharsCount(maxCharsContainer, remainingCharsCount);
        };
        update();

        element.addEventListener('keydown', update);
        element.addEventListener('keyup', update);
        element.addEventListener('keypress', update);
    },
};

export default maxChars;